import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LayoutAlignDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';

@Component({
  selector: 'bt-progress-overlay',
  templateUrl: './progress-overlay.component.html',
  styleUrls: ['./progress-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DecimalPipe,
    LayoutAlignDirective,
    LayoutDirective,
    LayoutGapDirective,
    MatProgressBar,
    MatProgressSpinner
  ]
})
export class ProgressOverlayComponent {
  progressValue = 0;

  public setProgressValue(value: number) {
    this.progressValue = value;
  }
}
